import { useEffect } from "react";
import { CircleMarker, MapContainer, TileLayer, useMap } from "react-leaflet";
import { useTheme } from "@mui/material";
import { MAP_ATTRIBUTION, MAP_TILE_URL } from "../../utils/constants/constants";

interface Props {
    latitude: number;
    longitude: number;
    height?: number;
}

// Leaflet measures its container on mount; the dialog's open transition leaves it mis-sized.
const InvalidateSizeOnMount = () => {
    const map = useMap();
    useEffect(() => {
        const timer = setTimeout(() => map.invalidateSize(), 300);
        return () => clearTimeout(timer);
    }, [map]);
    return null;
};

export const FacilityMap = ({ latitude, longitude, height = 250 }: Props) => {
    const theme = useTheme();

    return (
        <MapContainer
            key={`${latitude},${longitude}`}
            style={{ height: `${height}px`, width: "100%" }}
            center={[latitude, longitude]}
            zoom={16}
            scrollWheelZoom={false}
        >
            <InvalidateSizeOnMount />
            <TileLayer attribution={MAP_ATTRIBUTION} url={MAP_TILE_URL} />
            <CircleMarker
                center={[latitude, longitude]}
                radius={10}
                pathOptions={{
                    color: theme.palette.error.main,
                    fillColor: theme.palette.error.main,
                    fillOpacity: 0.6,
                }}
            />
        </MapContainer>
    );
};
